var videoListTag = document.createElement('script');
videoListTag.src = "https://www.youtube.com/iframe_api";
var videoListScriptTag = document.getElementsByTagName('script')[0];
videoListScriptTag.parentNode.insertBefore(videoListTag, videoListScriptTag);

const breakpointVideoList = window.matchMedia('(max-width: 768px)');
const currentVideo = document.getElementById('js-video-list__video');
const currentTitle = document.querySelector('.js-video-list__current-title');
const currentVideoContainer = document.getElementById('js-video-list__video-container');
const videoThumbs = document.querySelectorAll('[class^="js-video-list__thumb-"]');
const videoThumb = document.querySelector('.js-video-list__thumb-');
const currentVideoThumb = document.querySelector('.js-video-list__current-image');
const videoListContainer = document.getElementById('js-video-list__thumbs');
const videoItems = document.querySelectorAll('.video-list__item');
var videoListPlayer;
var videoListPlayerThumb = [];
let currentVideoId;

if(!breakpointVideoList.matches) {
  videoItemsCarousel();
}

function onYouTubeIframeAPIReady() {
  videoListPlayer = new YT.Player('js-video-list__video-main', {
    height: '100%',
    width: '100%',
    videoId: videoItems[0].dataset.videoItemId,
    playerVars: {
      'autoplay': 0,
      'controls': 0,
      'mute': 0,
      'loop': 1,
      'rel': 0,
      'autohide': 1,
      'showinfo': 0,
      'playlist': videoItems[0].dataset.videoItemId
    },
    events: {
      'onReady': onVideoListPlayerReady,
      'onStateChange': onVideoListPlayerStateChange
    }
  });

  videoItems.forEach((videoItem, eq) => {
    if(!videoItem.classList.contains('video-list__item--video-internal')) {
      let videoId = videoItem.dataset.videoItemId;
      videoListPlayerThumb[eq] = new YT.Player(videoItem.querySelector('.video-list__thumb-video'), {
        height: 0,
        width: 0,
        videoId: videoId,
        playerVars: {
          'autoplay': 0,
          'controls': 0,
          'mute': 1,
          'loop': 0,
          'rel': 0,
          'autohide': 1,
          'showinfo': 0,
          'playlist': videoId
        },
        events: {
          'onReady': event => {
            if(videoItem.querySelector('.js-video-list__duration')) {
              videoItem.querySelector('.js-video-list__duration').innerHTML = formatVideoTime(event.target.getDuration() - .5);
            }
          }
        }
      });
    } else { /* Internal video */
      const videoPlayerItem = videoItem.querySelector('.video-list__thumb-video');
      const videoEL = document.createElement('video'); 
      if(breakpointVideoList.matches) {
        videoEL.src = videoItem.dataset.videoItemUrlMobile; // Replace with your video URL
      } else {
        videoEL.src = videoItem.dataset.videoItemUrl; // Replace with your video URL
      }
      videoPlayerItem.appendChild(videoEL);
      videoEL.addEventListener('loadedmetadata', () => {
        if(videoItem.querySelector('.js-video-list__duration')) {
          videoItem.querySelector('.js-video-list__duration').innerHTML = formatVideoTime(videoEL.duration - .5);
        }
      });
    }
  });
}

function getVideoTime() {
  const videoPlayerInternal = document.getElementById('js-video-list__video-player');
  const currentTime = document.querySelector('.video-list__current-time');
  const currentDuration = document.querySelector('.video-list__current-duration');
  
  setTimeout(getVideoTime, 500);
  if(videoPlayerInternal.style.display == 'block') {
    document.querySelector('.video-list__progress').style.width = ((videoPlayerInternal.currentTime / videoPlayerInternal.duration) * 100) + '%'
    currentTime.innerHTML = formatVideoTime(videoPlayerInternal.currentTime);
    currentDuration.innerHTML = formatVideoTime(videoPlayerInternal.duration - .5);

    if(formatVideoTime(videoPlayerInternal.currentTime) == formatVideoTime(videoPlayerInternal.duration - .5)) {
      const activeVideo = document.querySelector('.video-list__item--active');
      activeVideo && activeVideo.click();
    }
  } else {
    document.querySelector('.video-list__progress').style.width = ((videoListPlayer.getCurrentTime() / videoListPlayer.getDuration()) * 100) + '%'
    currentTime.innerHTML = formatVideoTime(videoListPlayer.getCurrentTime());
    currentDuration.innerHTML = formatVideoTime(videoListPlayer.getDuration() - .5);

    if(formatVideoTime(videoListPlayer.getCurrentTime()) == formatVideoTime(videoListPlayer.getDuration() - .5)) {
      const activeVideo = document.querySelector('.video-list__item--active');
      activeVideo && activeVideo.click();
    }
  }
}

function onVideoListPlayerReady(event) {
  getVideoTime();

  const videoSoundControl = document.querySelector('.js-video-list__sound');
  if(videoSoundControl) {
    videoSoundControl.addEventListener('click', e => {
      const videoPlayerInternal = document.getElementById('js-video-list__video-player');
      if(videoPlayerInternal.style.display == 'block') {
        if(videoPlayerInternal.muted === true) {
          videoPlayerInternal.muted = false;
          e.currentTarget.classList.remove('video-list__sound--muted')
        } else {
          videoPlayerInternal.muted = true;
          e.currentTarget.classList.add('video-list__sound--muted')
        }
      } else {
        if (videoListPlayer.isMuted()) {
          videoListPlayer.unMute();
          e.currentTarget.classList.remove('video-list__sound--muted')
        } else {
          videoListPlayer.mute();
          e.currentTarget.classList.add('video-list__sound--muted')
        }
      }
    })
  }
  setTimeout(() => {
    const videoTopButtonPlay = document.querySelectorAll('.js-video-list__current-play');
    if(videoTopButtonPlay) {
      videoTopButtonPlay.forEach(playButton => {
        playButton.addEventListener('click', el => {
          const videoCurrentItem = document.querySelector('.video-list__item--active');
          const videoPlayerInternal = document.getElementById('js-video-list__video-player');
          if(videoPlayerInternal.style.display == 'block') {
            if(videoPlayerInternal.paused) {
              videoPlayerInternal.play();
              currentVideoThumb.style.opacity = 0;
              currentVideoThumb.style.visibility = 'hidden';
              el.currentTarget.classList.add('video-list__current-play--active');
              videoCurrentItem.classList.add('video-list__item--active');
              currentVideoThumb.style.zIndex = 0;
            } else {
              videoPlayerInternal.pause();
              currentVideoThumb.style.opacity = 1;
              currentVideoThumb.style.visibility = 'visible';
              el.currentTarget.classList.remove('video-list__current-play--active');
              videoCurrentItem.classList.remove('video-list__item--active');
              currentVideoThumb.removeAttribute('style');
            }
          } else {
            if (videoListPlayer.getPlayerState() === 1) {
              videoListPlayer.pauseVideo();
              currentVideoThumb.style.opacity = 1;
              currentVideoThumb.style.visibility = 'visible';
              el.currentTarget.classList.remove('video-list__current-play--active');
              videoCurrentItem.classList.remove('video-list__item--active');
              currentVideoThumb.removeAttribute('style');
            } else {
              videoListPlayer.playVideo();
              currentVideoThumb.style.opacity = 0;
              currentVideoThumb.style.visibility = 'hidden';
              el.currentTarget.classList.add('video-list__current-play--active');
              videoCurrentItem.classList.add('video-list__item--active');
              currentVideoThumb.style.zIndex = 0;
            }
          }
        })
      })
    }
  }, 200);
  if(videoItems) {
    setTimeout(() => {
      const videoTopImages = document.querySelectorAll('.js-video-list__current-image img, .video-list__play-current');
      if(videoTopImages) {
        videoTopImages.forEach(el => {
          el.addEventListener('click', () => {
            videoItems[0].click();
            const videoPlayerInternal = document.getElementById('js-video-list__video-player');
            if(videoPlayerInternal.style.display == 'block') {
              if(breakpointVideoList.matches) {
                playInternalVideo(videoItems[0].dataset.videoItemUrlMobile);
              } else {
                playInternalVideo(videoItems[0].dataset.videoItemUrl);
              }
            } 
          })
        })
      }
    }, 500);

    setTimeout(() => {
      const videoTopOverlay = document.querySelectorAll('.js-video-list__video-overlay');
      if(videoTopOverlay) {
        videoTopOverlay.forEach(el => {
          el.addEventListener('click', () => {
            const activeItem = document.querySelector('#js-video-list__video-container');
            let itemId = activeItem.dataset.videoItemId;
            if(breakpointVideoList.matches) {
              let videoItem = document.querySelector(`.video-list__item[data-video-item-id-mobile="${itemId}"]`);
              if(videoItem) {
                videoItem && videoItem.click();
              } else {
                videoItem = document.querySelector(`.video-list__item[data-video-item-id="${itemId}"]`);
                videoItem && videoItem.click();
              }
            } else {
              const videoItem = document.querySelector(`.video-list__item[data-video-item-id="${itemId}"]`);
              videoItem && videoItem.click();
            }
          })
        })
      }
    }, 500);

    videoItems.forEach((videoItem, eq) => {
      if(eq === 0) {
        currentVideoThumb.innerHTML = `<div class="video-list__play video-list__play-current"></div><img src="${videoItem.dataset.videoItemImage}" alt="${videoItem.dataset.videoItemTitle}">`;
        let itemId = videoItem.dataset.videoItemId;
        if(breakpointVideoList.matches) {
          itemId = videoItem.dataset.videoItemIdMobile;
          if(!itemId) {
            itemId = videoItem.dataset.videoItemId;
          }
        }
        currentVideoContainer.setAttribute('data-video-item-id', itemId);
        currentTitle.innerHTML = videoItem.dataset.videoItemTitle;
        let videoUrl = videoItem.dataset.videoItemUrl;
        if(breakpointVideoList.matches) {
          videoUrl = videoItem.dataset.videoItemUrlMobile;
          if(!videoUrl) {
            videoUrl = videoItem.dataset.videoItemUrl;
          }
        }
        loadInternalVideo(videoUrl);
      }

      videoItem.addEventListener('click', el => {
        let videoId = el.currentTarget.dataset.videoItemId;
        if(breakpointVideoList.matches) {
          videoId = el.currentTarget.dataset.videoItemIdMobile;
          if(!videoId) {
            videoId = el.currentTarget.dataset.videoItemId;
          }
        }

        const videoTitle = el.currentTarget.dataset.videoItemTitle;
        const videoImage = el.currentTarget.dataset.videoItemImage;
        currentVideoId = currentVideoContainer.getAttribute('data-video-item-id');
        if(videoItems) {
          videoItems.forEach(item => item.classList.remove('video-list__item--active'));
        }
        currentTitle.innerHTML = videoTitle;
        const videoPlayerYT = document.getElementById('js-video-list__video-main');
        const videoPlayerInternal = document.getElementById('js-video-list__video-player');
        if(currentVideoId !== videoId) {
          currentVideoContainer.setAttribute('data-video-item-id', videoId);
          if(!el.currentTarget.classList.contains('video-list__item--video-internal')) {
            videoListPlayer.loadVideoById(videoId) // Create the player and play the video
            videoPlayerYT.style.display = 'block';
            videoPlayerInternal.style.display = 'none';
            videoPlayerInternal.pause();
          } else {
            let videoUrl = el.currentTarget.dataset.videoItemUrl;
            if(breakpointVideoList.matches) {
              videoUrl = el.currentTarget.dataset.videoItemUrlMobile;
              if(!videoUrl) {
                videoUrl = el.currentTarget.dataset.videoItemUrl;
              }
            }
            videoPlayerYT.style.display = 'none';
            videoPlayerInternal.style.display = 'block';
            playInternalVideo(videoUrl);
            videoListPlayer.pauseVideo();
          }
          el.currentTarget.classList.add('video-list__item--active');
          currentVideoThumb.innerHTML = `<div class="video-list__play video-list__play-current"></div><img src="${videoImage}" alt="${videoTitle}">`;
          currentVideoThumb.style.opacity = 0;
          currentVideoThumb.style.visibility = 'hidden';
          currentVideoThumb.style.zIndex = 0;
        } else {
          if(!el.currentTarget.classList.contains('video-list__item--video-internal')) {
            const videoPlayerYT = document.getElementById('js-video-list__video-main');
            const videoPlayerInternal = document.getElementById('js-video-list__video-player');
            videoPlayerInternal.style.display = 'none';
            videoPlayerYT.style.display = 'block';
            if(videoListPlayer) {
              if (videoListPlayer.getPlayerState() === 1) {
                videoListPlayer.pauseVideo();
                currentVideoThumb.style.opacity = 1;
                currentVideoThumb.style.visibility = 'visible';
                el.currentTarget.classList.remove('video-list__item--active');
                currentVideoThumb.innerHTML = `<div class="video-list__play video-list__play-current"></div><img src="${videoImage}" alt="${videoTitle}">`;
                currentVideoThumb.removeAttribute('style');
  
                setTimeout(() => {
                  const videoTopImages = document.querySelectorAll('.js-video-list__current-image img, .video-list__play-current');
                  if(videoTopImages) {
                    videoTopImages.forEach(el => {
                      el.addEventListener('click', () => {
                        const activeItem = document.querySelector('#js-video-list__video-container');
                        let itemId = activeItem.dataset.videoItemId;
                        if(breakpointVideoList.matches) {
                          let videoItem = document.querySelector(`.video-list__item[data-video-item-id-mobile="${itemId}"]`);
                          if(videoItem) {
                            videoItem && videoItem.click();
                          } else {
                            videoItem = document.querySelector(`.video-list__item[data-video-item-id="${itemId}"]`);
                            videoItem && videoItem.click();
                          }
                        } else {
                          const videoItem = document.querySelector(`.video-list__item[data-video-item-id="${itemId}"]`);
                          videoItem && videoItem.click();
                        }
                      })
                    })
                  }
                }, 500);
              } else {
                videoListPlayer.playVideo();
                currentVideoThumb.style.opacity = 0;
                currentVideoThumb.style.visibility = 'hidden';
                el.currentTarget.classList.add('video-list__item--active');
                currentVideoThumb.style.zIndex = 0;
              }
            }
          } else {
            const videoPlayerYT = document.getElementById('js-video-list__video-main');
            const videoPlayerInternal = document.getElementById('js-video-list__video-player');
            videoPlayerYT.style.display = 'none';
            videoPlayerInternal.style.display = 'block';
          
            if(videoPlayerInternal.paused) {
              videoPlayerInternal.play();
              currentVideoThumb.style.opacity = 0;
              currentVideoThumb.style.visibility = 'hidden';
              el.currentTarget.classList.add('video-list__item--active');
              currentVideoThumb.style.zIndex = 0;
            } else {
              videoPlayerInternal.pause();
              currentVideoThumb.style.opacity = 1;
              currentVideoThumb.style.visibility = 'visible';
              el.currentTarget.classList.remove('video-list__item--active');
              currentVideoThumb.innerHTML = `<div class="video-list__play video-list__play-current"></div><img src="${videoImage}" alt="${videoTitle}">`;
              currentVideoThumb.removeAttribute('style');

              setTimeout(() => {
                const videoTopImages = document.querySelectorAll('.js-video-list__current-image img, .video-list__play-current');
                if(videoTopImages) {
                  videoTopImages.forEach(el => {
                    el.addEventListener('click', () => {
                      const activeItem = document.querySelector('#js-video-list__video-container');
                      let itemId = activeItem.dataset.videoItemId;
                      if(breakpointVideoList.matches) {
                        let videoItem = document.querySelector(`.video-list__item[data-video-item-id-mobile="${itemId}"]`);
                        if(videoItem) {
                          videoItem && videoItem.click();
                        } else {
                          videoItem = document.querySelector(`.video-list__item[data-video-item-id="${itemId}"]`);
                          videoItem && videoItem.click();
                        }
                      } else {
                        const videoItem = document.querySelector(`.video-list__item[data-video-item-id="${itemId}"]`);
                        videoItem && videoItem.click();
                      }
                    })
                  })
                }
              }, 500);
            }
          }
        }
      });
    })
  }
}

function loadInternalVideo(videoSrc, title) {
  const videoPlayer = document.getElementById('js-video-list__video-player');
  const videoSource = document.getElementById('js-video-list__video-source');

  // Set the source of the video player to the selected video
  videoSource.src = videoSrc;
  videoPlayer.load();
}

function playInternalVideo(videoSrc, title) {
  const videoPlayer = document.getElementById('js-video-list__video-player');
  const videoSource = document.getElementById('js-video-list__video-source');

  videoSource.src = videoSrc;
  videoPlayer.load();
  videoPlayer.play();
}

function videoItemsCarousel() {
  const videoItemsSlider = document.querySelector('#js-video-list__swiper');
  new Swiper(videoItemsSlider, {
    init: true,
    spaceBetween: 0,
    slidesPerView: 5,
    navigation: {
      nextEl: '.video-list__button-next',
      prevEl: '.video-list__button-prev',
    },
  });
}

function onVideoListPlayerStateChange(event) {}